import { useRoutes, type RouteObject } from "react-router-dom-v5-compat";
import { TripsApp } from "@b2bportal/core-trips";
import { TRIPS_PATH } from "@b2bportal/core-utilities";
import type { Product } from "@b2bportal/purchase-api";
import { type HotelTripProduct, useHotelTripProduct } from "@tenant/hotels";
import { MyTripsPage } from "./components/MyTripsPage";
import {
  useCarsTripProduct,
  type CarTripProduct,
} from "./hooks/useCarsTripProduct";
import { SelfServeHotelCancelPageRoute } from "./SelfServeHotelCancel/SelfServeHotelCancel.route";
import { usePageTitle } from "@/utils/title";
import { hotelItineraryPath } from "@/utils/trips";

export const TRIPS_CANCEL_HOTEL_PATH = "/hotel/cancel/:reservationId";
export const TRIPS_CANCEL_HOTEL_ROUTE = `${TRIPS_PATH}${TRIPS_CANCEL_HOTEL_PATH}`;

type ListProducts = {
  [Product.Hotel]: HotelTripProduct;
  [Product.Ground]?: CarTripProduct;
};

const TripsAppWithProducts = ({
  products,
  pastProducts,
  additionalRoutes,
}: {
  products: ListProducts;
  pastProducts: ListProducts;
  additionalRoutes: RouteObject[];
}) => {
  const routes = useRoutes([
    {
      path: "/",
      element: <MyTripsPage products={products} pastProducts={pastProducts} />,
    },
    {
      path: TRIPS_CANCEL_HOTEL_PATH,
      element: <SelfServeHotelCancelPageRoute />,
    },
    ...additionalRoutes,
  ]);

  return <TripsApp>{routes}</TripsApp>;
};

export const Trips = () => {
  usePageTitle("My Trips");

  const { hotels, pastHotels, hotelReservationRouteProps } =
    useHotelTripProduct({
      tripsPath: TRIPS_PATH,
      reservationPath: hotelItineraryPath,
    });

  const { cars, pastCars } = useCarsTripProduct();

  return (
    <TripsAppWithProducts
      products={{ ...hotels, ...cars }}
      pastProducts={{ ...pastHotels, ...pastCars }}
      additionalRoutes={[hotelReservationRouteProps]}
    />
  );
};
